import { ActionTypes } from "../constants/ActionTypes";

var initialState = {
    allUser: null,
    user: null,
    trial: false,
    message: "",
}

const Users = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.GET_ALL_USER_DATA_ATTEMPT:
            return { ...state, allUser: null, trial: true, message: "" };
        case ActionTypes.GET_ALL_USER_DATA_SUCCESS:
            return { ...state, allUser: payload, trial: false, message: "" };
        case ActionTypes.GET_ALL_USER_DATA_FAIL:
            return { ...state, allUser: null, trial: false, message: payload };

        case ActionTypes.SET_PROFILE:
            return { ...state, user: payload, message: "" }
        case ActionTypes.SET_PROFILE_FAIL:
            return { ...state, user: null, message: "Something went wrong" }

        case ActionTypes.SET_PROFILE_FAIL:
            return { state: initialState }


        default:
            return state
    }
}


export default Users